class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !parsedState.sections || !parsedState.sections[section.id]) return;

      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.updateCartBubbleCount();

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      }
    ];
  }

  updateCartBubbleCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (!cartIcon) return;

        let bubble = cartIcon.querySelector('.cart-count-bubble');

        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = `
              <span aria-hidden="true"></span>
              <span class="visually-hidden"></span>
            `;
            cartIcon.appendChild(bubble);
          }

          const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
          const hiddenCount = bubble.querySelector('.visually-hidden');

          if (visibleCount) visibleCount.textContent = cart.item_count < 100 ? cart.item_count : '';
          if (hiddenCount) hiddenCount.textContent = `${cart.item_count} producten in winkelwagen`;
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch((error) => console.error('Cart count update failed:', error));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
